import React from 'react'

import { EuiButtonEmpty, EuiFieldText, EuiFlexGroup, EuiFlexItem, EuiFormRow, EuiPanel, EuiText } from '@elastic/eui'

export interface CreativeCardLink {
  value: string
  isInvalid: boolean
  onChange: (link: string) => void
}

export interface ICreativeCard {
  id: string
  fileName: string
  details?: string
  warning?: string
  link?: CreativeCardLink
  onRemove: () => void
  children: React.ReactNode
}

const cardWidth = 280
const previewHeight = 150

export const CreativeCard: React.FC<ICreativeCard> = ({ id, fileName, details, warning, link, onRemove, children }) => (
  <EuiPanel hasBorder hasShadow={false} grow={false} paddingSize='s' style={{ width: cardWidth }} color={warning ? 'subdued' : 'plain'}>
    <EuiFlexGroup direction='column' gutterSize='s'>
      <EuiFlexItem grow={false} style={{ height: previewHeight, alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
        {children}
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <EuiText size='xs' className='eui-textTruncate' title={fileName}>
          <strong>{fileName}</strong>
        </EuiText>
        {details && (
          <EuiText size='xs' color='subdued'>
            {details}
          </EuiText>
        )}
        {warning && (
          <EuiText size='xs' color='warning'>
            {warning}
          </EuiText>
        )}
      </EuiFlexItem>
      {link && (
        <EuiFlexItem grow={false}>
          <EuiFormRow id={`${id}-link`} label='Link' isInvalid={link.isInvalid} error='Enter a valid link' display='rowCompressed'>
            <EuiFieldText compressed placeholder='https://...' value={link.value} onChange={e => link.onChange(e.target.value)} isInvalid={link.isInvalid} />
          </EuiFormRow>
        </EuiFlexItem>
      )}
      <EuiFlexItem grow={false}>
        <EuiButtonEmpty iconType='cross' color='danger' size='xs' flush='left' onClick={onRemove}>
          Remove
        </EuiButtonEmpty>
      </EuiFlexItem>
    </EuiFlexGroup>
  </EuiPanel>
)
